import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import useOperationalAccess from "app/hooks/useOperationalAccess";
import {
  PHARMACY_SETUP_TABS,
  resolveActiveTabPath,
  tabVisible,
} from "./pharmacySetupNav";

/**
 * Pharmacy Setup workspace chrome — Lab Catalog C1 tab pattern.
 * Composes existing Pharmacy master routes; does not change page business logic.
 */
export default function PharmacySetupC1Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { canAccessModule } = useOperationalAccess();

  const visibleTabs = PHARMACY_SETUP_TABS.filter((tab) => tabVisible(tab, canAccessModule));
  const current = resolveActiveTabPath(
    location.pathname,
    visibleTabs.length ? visibleTabs : PHARMACY_SETUP_TABS,
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: 0, height: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          px: { xs: 1, sm: 2 },
          flexShrink: 0,
        }}
      >
        <Tabs
          value={visibleTabs.some((t) => t.path === current) ? current : false}
          onChange={(_, value) => navigate(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 42,
            "& .MuiTab-root": { minHeight: 42, py: 1, fontSize: "0.8rem", fontWeight: 700 },
          }}
        >
          {visibleTabs.map((item) => (
            <Tab key={item.path} label={item.label} value={item.path} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
